// It is recommended to not edit this file once it has been generated
import {
  GetApiAdminControllersV1ApiResponse,
  GetApiAdminUpdatesV1ByIdApiResponse,
  GetApiControllersV1ByIdAlarmsV1ApiResponse,
  GetApiControllersV1ByIdMetersettingsV1ApiResponse,
  GetApiControllersV1ByIdNotificationsettingsV1ApiResponse,
  GetApiControllersV1ApiResponse,
  newApi,
} from "./newApi";

// correct typing for the enhanceEndpoints
export const enhancedAPI = newApi.enhanceEndpoints({
  endpoints: {
    getApiAdminControllersV1: {
      providesTags: (result: GetApiAdminControllersV1ApiResponse | undefined) =>
        result
          ? [
              ...result.map(({ id }) => ({
                type: "AdminControllers" as const,
                id,
              })),
              { type: "AdminControllers", id: "LIST" },
            ]
          : [{ type: "AdminControllers", id: "LIST" }],
    },
    postApiAdminControllersV1: {
      invalidatesTags: [{ type: "AdminControllers", id: "LIST" }],
    },
    getApiAdminControllersV1ById: {
      providesTags: (result: any, error: any, arg: { id: any }) => [
        { type: "AdminControllers", id: arg.id },
      ],
    },
    putApiAdminControllersV1ById: {
      invalidatesTags: (result: any, error: any, arg: { id: any }) => [
        { type: "AdminControllers", id: arg.id },
        { type: "AdminControllers", id: "LIST" },
      ],
    },
    postApiAdminToolsV1TestSendEmailV1: {
      // No specific invalidatesTags as it's a test endpoint
    },
    getApiAdminUpdatesV1: {
      providesTags: (result: any) =>
        result
          ? [
              ...result.map(({ id }: any) => ({ type: "Updates" as const, id })),
              { type: "Updates", id: "LIST" },
            ]
          : [{ type: "Updates", id: "LIST" }],
    },
    postApiAdminUpdatesV1: {
      invalidatesTags: [{ type: "Updates", id: "LIST" }],
    },
    getApiAdminUpdatesV1ById: {
      providesTags: (
        result: GetApiAdminUpdatesV1ByIdApiResponse | undefined,
        error: any,
        arg: { id: any },
      ) => [{ type: "Updates", id: arg.id }],
    },
    putApiAdminUpdatesV1ById: {
      invalidatesTags: (result: any, error: any, arg: { id: any }) => [
        { type: "Updates", id: arg.id },
        { type: "Updates", id: "LIST" },
      ],
    },
    deleteApiAdminUpdatesV1ById: {
      invalidatesTags: (result: any, error: any, arg: { id: any }) => [
        { type: "Updates", id: arg.id },
        { type: "Updates", id: "LIST" },
      ],
    },
    postApiAdminUpdatesV1ByIdAssign: {
      invalidatesTags: (result: any, error: any, arg: { body: any[] }) => [
        { type: "AdminControllers", id: "LIST" },
        ...arg.body.map((id) => ({ type: "AdminControllers" as const, id })),
      ],
    },
    getApiAdminUsersV1: {
      providesTags: (result: any) =>
        result
          ? [
              ...result.map(({ id }: any) => ({
                type: "AdminUsers" as const,
                id,
              })),
              { type: "AdminUsers", id: "LIST" },
            ]
          : [{ type: "AdminUsers", id: "LIST" }],
    },
    postApiAdminUsersV1: {
      invalidatesTags: [{ type: "AdminUsers", id: "LIST" }],
    },
    getApiAdminUsersV1ById: {
      providesTags: (result: any, error: any, arg: { id: any }) => [
        { type: "AdminUsers", id: arg.id },
      ],
    },
    putApiAdminUsersV1ById: {
      invalidatesTags: (result: any, error: any, arg: { id: any }) => [
        { type: "AdminUsers", id: arg.id },
        { type: "AdminUsers", id: "LIST" },
      ],
    },
    postApiAdminUsersV1ByIdResetPassword: {
      invalidatesTags: ["AdminUpdateUserPassword"],
    },
    postApiAdminUsersV1ByIdSendPasswordV1: {
      invalidatesTags: ["AdminSendNewUserPassword"],
    },
    postApiControllerAlarmV1: {
      invalidatesTags: ["Alarms"],
    },
    deleteApiControllerAlarmsV1: {
      invalidatesTags: ["Alarms"],
    },
    getApiControllerConfigV1: {
      providesTags: ["Controllers"],
    },
    postApiControllerConfigV1: {
      invalidatesTags: ["Controllers"],
    },
    postApiControllerHeatcurveV1: {
      invalidatesTags: ["Controllers"],
    },
    postApiControllerMeterV1: {
      invalidatesTags: ["Meters"],
    },
    postApiControllerMetricsV1: {
      invalidatesTags: ["Metrics"],
    },
    getApiControllerScheduleV1: {
      providesTags: ["Controllers"],
    },
    postApiControllerUpdateLogV1: {
      invalidatesTags: ["UpdateLogs"],
    },
    getApiControllerUpdateV1: {
      // No tags as it provides update file metadata
    },
    getApiControllersV1: {
      providesTags: (result: GetApiControllersV1ApiResponse | undefined) =>
        result
          ? [
              ...result.map(({ id }) => ({ type: "Controllers" as const, id })),
              { type: "Controllers", id: "LIST" },
            ]
          : [{ type: "Controllers", id: "LIST" }],
    },
    postApiControllersV1: {
      invalidatesTags: [{ type: "Controllers", id: "LIST" }],
    },
    getApiControllersV1ById: {
      providesTags: (result: any, error: any, arg: { id: any }) => [
        { type: "Controllers", id: arg.id },
      ],
    },
    putApiControllersV1ById: {
      invalidatesTags: (result: any, error: any, arg: { id: any }) => [
        { type: "Controllers", id: arg.id },
        { type: "Controllers", id: "LIST" },
      ],
    },
    getApiControllersV1ByIdAlarmsV1: {
      providesTags: (
        result: GetApiControllersV1ByIdAlarmsV1ApiResponse | undefined,
      ) =>
        result
          ? [
              ...result.map(({ id }) => ({ type: "Alarms" as const, id })),
              { type: "Alarms", id: "LIST" },
            ]
          : [{ type: "Alarms", id: "LIST" }],
    },
    getApiControllersV1ByIdLastmetricsV1: {
      providesTags: ["Metrics"],
    },
    getApiControllersV1ByIdMetersettingsV1: {
      providesTags: (
        result: GetApiControllersV1ByIdMetersettingsV1ApiResponse | undefined,
      ) =>
        result
          ? [
              ...result.map(({ id }) => ({ type: "Meters" as const, id })),
              { type: "Meters", id: "LIST" },
            ]
          : [{ type: "Meters", id: "LIST" }],
    },
    postApiControllersV1ByIdMetersettingsV1: {
      invalidatesTags: [{ type: "Meters", id: "LIST" }],
    },
    getApiControllersV1ByIdMetersettingsV1AndMeter: {
      providesTags: (result: any, error: any, arg: { meter: any }) => [
        { type: "Meters", id: arg.meter },
      ],
    },
    putApiControllersV1ByIdMetersettingsV1AndMeter: {
      invalidatesTags: (result: any, error: any, arg: { meter: any }) => [
        { type: "Meters", id: arg.meter },
        { type: "Meters", id: "LIST" },
      ],
    },
    deleteApiControllersV1ByIdMetersettingsV1AndMeter: {
      invalidatesTags: (result: any, error: any, arg: { meter: any }) => [
        { type: "Meters", id: arg.meter },
        { type: "Meters", id: "LIST" },
      ],
    },
    getApiControllersV1ByIdMetricsV1: {
      providesTags: ["Metrics"],
    },
    getApiControllersV1ByIdNotificationsettingsV1: {
      providesTags: (
        result:
          | GetApiControllersV1ByIdNotificationsettingsV1ApiResponse
          | undefined,
      ) =>
        result
          ? [
              ...result.map(({ id }) => ({
                type: "NotificationSettings" as const,
                id,
              })),
              { type: "NotificationSettings", id: "LIST" },
            ]
          : [{ type: "NotificationSettings", id: "LIST" }],
    },
    postApiControllersV1ByIdNotificationsettingsV1: {
      invalidatesTags: [{ type: "NotificationSettings", id: "LIST" }],
    },
    getApiControllersV1ByIdNotificationsettingsV1AndSetting: {
      providesTags: (result: any, error: any, arg: { setting: any }) => [
        { type: "NotificationSettings", id: arg.setting },
      ],
    },
    putApiControllersV1ByIdNotificationsettingsV1AndSetting: {
      invalidatesTags: (result: any, error: any, arg: { setting: any }) => [
        { type: "NotificationSettings", id: arg.setting },
        { type: "NotificationSettings", id: "LIST" },
      ],
    },
    deleteApiControllersV1ByIdNotificationsettingsV1AndSetting: {
      invalidatesTags: (result: any, error: any, arg: { setting: any }) => [
        { type: "NotificationSettings", id: arg.setting },
        { type: "NotificationSettings", id: "LIST" },
      ],
    },
    getApiEnergyPricesV1: {
      providesTags: (result: any) =>
        result
          ? [
              ...result.map(({ time }: any) => ({ type: "Energy" as const, id: time })),
              { type: "Energy", id: "LIST" },
            ]
          : [{ type: "Energy", id: "LIST" }],
    },
    postApiLoginV1: {
      invalidatesTags: ["Auth"],
    },
    getApiLogoutV1: {
      providesTags: ["Auth"],
    },
    postApiResetPasswordV1ByToken: {
      invalidatesTags: ["Auth"],
    },
    getApiSettingsV1: {
      providesTags: ["Settings"],
    },
    putApiSettingsV1: {
      invalidatesTags: ["Settings"],
    },
    getApiStatisticsConsumptionV1: {
      providesTags: ["Statistics"],
    },
    getApiTenantsV1: {
      providesTags: (result: any) =>
        result
          ? [
              ...result.map(({ id }: any) => ({ type: "Tenants" as const, id })),
              { type: "Tenants", id: "LIST" },
            ]
          : [{ type: "Tenants", id: "LIST" }],
    },
    postApiTenantsV1: {
      invalidatesTags: [{ type: "Tenants", id: "LIST" }],
    },
    getApiTenantsV1ById: {
      providesTags: (result: any, error: any, arg: { id: any }) => [
        { type: "Tenants", id: arg.id },
      ],
    },
    putApiTenantsV1ById: {
      invalidatesTags: (result: any, error: any, arg: { id: any }) => [
        { type: "Tenants", id: arg.id },
        { type: "Tenants", id: "LIST" },
      ],
    },
    postApiTenantsV1ByIdSupportLoginV1: {
      invalidatesTags: (result: any, error: any, arg: { id: any }) => [
        { type: "Tenants", id: arg.id },
        { type: "Tenants", id: "LIST" },
      ],
    },
    postApiTokenV1: {
      invalidatesTags: ["Auth"],
    },
    getApiUsersV1: {
      providesTags: (result: any) =>
        result
          ? [
              ...result.map(({ id }: any) => ({ type: "User" as const, id })),
              { type: "User", id: "LIST" },
            ]
          : [{ type: "User", id: "LIST" }],
    },
  },
});

